import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/core/request/request.service';

export type CsvLoadType = 'NHC' | 'PETICIONES';

export interface CsvLoadErrorItem {
  fila: number;
  valor: string;
  descripcion: string;
}

export interface CsvLoadSuccess {
  type: CsvLoadType;
  values: string[];
  total_filas: number;
  total_duplicados: number;
  total_cargados: number;
}

export interface CsvLoadError {
  total_filas?: number;
  total_errores?: number;
  errors: CsvLoadErrorItem[];
}

@Injectable({
  providedIn: 'root',
})
export class CsvLoadService {
  constructor(private readonly request: RequestService) {}

  uploadCsv(
    type: CsvLoadType,
    file: File,
    queryName: string
  ): Observable<CsvLoadSuccess> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('queryName', queryName || '');

    return this.request.post(`/api/csv-load/${type}`, formData);
  }
}
